import React, { useContext, useMemo } from 'react'
import actions from 'redux/actions'
import cookie from 'js-cookie'
import GlobalsContext from 'sb-hooks/GlobalsContext' // important to import from sb-hooks/ in case of webpack config "externals"


const createRedirect = (setRedirectLink) => (link) => {
  if (setRedirectLink) {
    setRedirectLink(link)
  }
  else {
    actions.models.router.replace(link)
  }
}

const createAbValueGetter = (abTests) => (name) => {
  const ab = abTests[name]

  if (!ab || !ab.value) {
    return 'a'
  }

  return ab.value
}

const createCookieValueGetter = (cookies) => (name) => {
  if (process.env.WEBPACK === 'build.server') {
    let cookieValue

    try {
      cookieValue = JSON.parse(cookies[name])
    }
    catch (err) {
      cookieValue = cookies[name]
    }

    return cookieValue
  }

  return cookie.getJSON(name)
}

const createFeatureValueGetter = (features) => (name) => features[name]

/**
 *
 * @param {Object} storeProps
 * @param {Array} deps
 * @returns {*}
 */
const useGlobals = (storeProps, deps = []) => {
  const { globals } = useContext(GlobalsContext)

  return useMemo(() => {
    const { setRedirectLink, cookies, features, abTests } = globals || {}
    let data = {}

    const getAbValue        = createAbValueGetter(abTests)
    const getFeatureValue   = createFeatureValueGetter(features)
    const getCookieValue    = createCookieValueGetter(cookies)
    const redirect          = createRedirect(setRedirectLink)

    const props = {
      globals,
      setRedirectLink,
      getAbValue,
      getCookieValue,
      getFeatureToggle: getFeatureValue,
      redirect,
    }

    if (typeof storeProps === 'function') {
      data = storeProps(props)
    }
    else {
      Object.keys(storeProps).forEach((key) => {
        data[key] = storeProps[key](props)
      })
    }

    return data
  }, [ ...deps, globals ])
}


export default useGlobals
